import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import MapTooltip from './MapTooltip';
import MobileMapDropdown from './MobileMapDropdown';
import SvgMap from './SvgMap';

export default class InteractiveMapSvg extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showToolTip: false,
    };

    this.showToolTip = (e) => {
      const bodyPos = this.svgMap.getBoundingClientRect();
      const el = e.currentTarget.querySelector('path');
      const elPos = el.getBoundingClientRect();
      const topOffset = elPos.top - bodyPos.top;
      const leftOffset = elPos.left - bodyPos.left;

      const stateName = (e.currentTarget.dataset) ? e.currentTarget.dataset.state : e.currentTarget.getAttribute('data-state');
      const stateObject = this.props.states[stateName];
      if (stateObject && stateObject.highestTier) {
        // IE11 does not support classList inside of svgs, how lame is that?
        const stateCLass = `tier${stateObject.highestTier}`;
        const oldClass = el.getAttribute('class');
        el.setAttribute('class', `${oldClass} ${stateCLass}`);
      } else {
        const textNode = e.currentTarget.querySelector('.interactive-map-state-text');
        // IE11 doesn't support classList in svg
        const oldClass = textNode.getAttribute('class');
        textNode.setAttribute('class', `${oldClass} insufficient-data`);
      }
      this.setState({
        showToolTip: true,
        tooltipRegion: stateName,
        tooltipTopOffset: topOffset,
        tooltipLeftOffset: leftOffset,
        tooltipWidthOffset: elPos.width,
        tooltipHeightOffset: elPos.height,
        currentStateNode: e.currentTarget,
      });
    };

    this.hideToolTip = () => {
      const currentState = this.state.currentStateNode;
      if (currentState) {
        // IE11 doesn't support classList in svg
        const newClass = currentState.getAttribute('class').replace(' active', '');
        currentState.setAttribute('class', `${newClass}`);
      }
      this.setState({
        showToolTip: false,
      });
    };

    this.enterTooltip = () => {
      const currentState = this.state.currentStateNode;
      if (currentState) {
        // IE11 doesn't support classList in svg
        const oldClass = currentState.getAttribute('class');
        currentState.setAttribute('class', `${oldClass} active`);
      }
      this.setState({
        showToolTip: true,
      });
    };
  }

  render() {
    const containerStyle = {
      position: 'relative',
      textAlign: 'center',
    };

    return (
      <div style={containerStyle}>
        <MediaQuery minWidth={992} values={this.props.mediaQueryValues}>
          <MapTooltip
            showToolTip={this.state.showToolTip}
            tooltipRegion={this.state.tooltipRegion}
            tooltipTopOffset={this.state.tooltipTopOffset}
            tooltipLeftOffset={this.state.tooltipLeftOffset}
            tooltipWidthOffset={this.state.tooltipWidthOffset}
            tooltipHeightOffset={this.state.tooltipHeightOffset}
            enterTooltip={this.enterTooltip}
            leaveTooltip={this.hideToolTip}
            {...this.props}
          />
        </MediaQuery>
        <SvgMap
          svgRef={(svgMap) => { this.svgMap = svgMap; }}
          showToolTipFunc={this.showToolTip}
          hideToolTipFunc={this.hideToolTip}
          {...this.props}
        />
        {this.props.footerTemplate}
        <MediaQuery maxWidth={992} values={this.props.mediaQueryValues}>
          <MobileMapDropdown
            {...this.props}
          />
        </MediaQuery>
      </div>
    );
  }
}

InteractiveMapSvg.defaultProps = {
  // should not be passed by default, only used in testing
  mediaQueryValues: {},
};

InteractiveMapSvg.propTypes = {
  states: PropTypes.shape({
  }).isRequired,
  mediaQueryValues: PropTypes.shape({}),
  footerTemplate: PropTypes.element.isRequired,
};



// WEBPACK FOOTER //
// ./src-react/UsaMap/components/InteractiveMapSvg.jsx